import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import { Measurements } from '~/utility/BinSentry-ui-utility';
import '../../common/bn-placeholder';

class BinCurrentWeight extends LitEntity {
  static get styles() {
    return sharedStyles;
  }

  render() {
    if (this.weight === undefined) {
      return html`<bn-placeholder></bn-placeholder>`;
    }
    const measurement = Measurements.get('weight');
    return measurement.html({ weight: this.weight });
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }
    this.weight = this.entity.properties.weight / 1000;
  }
}

window.customElements.define('bin-current-weight', BinCurrentWeight);
